import { ProductInfo } from './types'
import productImagePlaceholder from 'Assets/images/product_img_placeholder.png'

/**
 * Check if a value is selected in the array
 */
export const isValueSelected = (optionValue: string, selectedValues: string[]): boolean => {
  if (!selectedValues) return false
  return selectedValues.includes(optionValue)
}

/**
 * Parse import text into product IDs
 */
export const parseImportText = (importText: string): string[] => {
  return importText
    .split(/[\s,\n]+/)
    .map(id => id.trim())
    .filter(id => id.length > 0)
}

/**
 * Create fallback product info
 */
export const createFallbackProductInfo = (id: string): ProductInfo => ({
  label: id,
  value: id,
  image: productImagePlaceholder
})

/**
 * Check if a product has complete information
 */
export const hasCompleteProductInfo = (
  value: string, 
  localProductsInfo: { [key: string]: ProductInfo }
): boolean => {
  const hasStoredInfo = localProductsInfo[value]
  return Boolean(hasStoredInfo && 
         hasStoredInfo.label && 
         hasStoredInfo.label !== value &&
         hasStoredInfo.value)
}

/**
 * Find matching option by various properties
 */
export const findMatchingOption = (
  value: string, 
  options: ProductInfo[]
): ProductInfo | undefined => {
  return options.find(opt => {
    return (
      opt.value === value ||
      (opt as any).code === value ||
      (opt as any).id === value
    )
  })
}

/**
 * Split array into batches
 */
export const splitIntoBatches = <T>(array: T[], batchSize: number): T[][] => {
  const batches: T[][] = []
  for (let i = 0; i < array.length; i += batchSize) {
    batches.push(array.slice(i, i + batchSize))
  }
  return batches
}

/**
 * Inject CSS styles if not already present
 */
export const injectStyles = (styleId: string, styles: string): void => {
  if (typeof document !== 'undefined' && !document.getElementById(styleId)) {
    const style = document.createElement('style')
    style.id = styleId
    style.textContent = styles
    document.head.appendChild(style)
  }
}

/**
 * Check if segment type is product-related
 */
export const isProductSegmentType = (segmentType?: string): boolean => {
  const productTypes = [
    'PRODUCT_COUNT',
    'PCM_PURCHASED_PRODUCT',
    'APP_ADD_TO_CART_PRODUCT', 
    'WEB_ADD_TO_CART_PRODUCT',
    'appAddToCart',
    'webAddToCart',
  ]
  return productTypes.includes(segmentType!)
} 